import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import {
  basicDetails,
  getBasicDetails,
  getPinCodeInfo
} from '../../../common/constants/api';
import './NewBasicDetails.css';
import { Form, useFormikContext } from 'formik';
import { useFormikWizard } from 'formik-wizard';
import * as Yup from 'yup';
import { setToken } from '../../../common/utils/auth-utils';
import getAuthToken from '../../../common/utils/cookie-utils';
import Checked from '../../../images/icons/checkbox_ok.svg';
import CommonInput from '../CommonComponent/CommonInput';
import CommonSelect from '../CommonComponent/CommonSelect';
import CommonPincode from '../CommonComponent/CommonPincode';
import Axios from 'axios';
import CommonDatePicker, {
  currentYear
} from '../CommonComponent/CommonDatePicker';

const NewBasicDetails = props => {
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(true);

  const [pincodeStatus, setPincodeStatus] = useState(false);

  const [showOtpBox, setShowOtpBox] = useState('false');
  // const [name, setName] = useState("manish");
  const userDetailsLength = Object.keys(userDetails).length > 0;
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    status,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = useFormikContext();

  return (
    <>
      <h1 className="text-center text-2xl py-4 font-khand text-xl font-semibold">
        Basic Details
      </h1>
      <div className=" m-2 md:mx-auto p-8 py-10 md:p-8 basic_container_box bg-white shadow-lg rounded-lg">
        <div className="name_field ">
          <div className="grid_input_container mb-10">
            <div>
              <CommonInput
                name="Name"
                id="Name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.Name}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="First Name"
                error={touched.Name && errors.Name}
                errorMsg={errors.Name}
                touched={touched.Name}
              />
            </div>
          </div>
        </div>

        {/* ///////// */}
        <div className="name_field ">
          <div className="grid_input_container mb-10">
            <div>
              <CommonInput
                name="lastName"
                id="lastName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.lastName}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                error={touched.lastName && errors.lastName}
                errorMsg={errors.lastName}
                legendName="Last Name"
                touched={touched.lastName}
              />
            </div>
          </div>
        </div>

        <div className="email_field">
          <div className="grid_input_container mb-10">
            <div className="date_container">
              <CommonInput
                name="email"
                id="email"
                onChange={handleChange}
                onBlur={e => {
                  handleBlur(e);
                  setShowOtpBox(true);
                }}
                value={values.email}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Email"
                placeholder="abc@gmail.com"
                error={touched.email && errors.email}
                errorMsg={errors.email}
                touched={touched.email}
                disabled
              />

              <img className="checked_img" src={Checked} />
            </div>
          </div>
        </div>
        <div className="mobile_field">
          <div className="grid_input_container relative mb-6">
            <div
              style={{ marginTop: '17px' }}
              className="absolute text-grey-50 z-10  pt-px text-md ml-4"
            >
              +91
            </div>
            <div>
              <CommonInput
                name="mobile"
                id="mobile"
                disabled
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.mobile}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                inputStyle={{
                  paddingLeft: '40px',
                  letterSpacing: '1px'
                }}
                onBlurStyle={{
                  paddingLeft: '20px'
                }}
                legendStyle={{
                  paddingLeft: errors.mobile ? '20px' : ''
                }}
                legendName="Mobile Number"
                error={touched.mobile && errors.mobile}
                errorMsg={errors.mobile}
                className={`pt-24`}
                touched={touched.mobile}
              />
            </div>

            <img className="checked_img" src={Checked} />
          </div>
        </div>
        <div className="DOB_field ">
          <div className="grid_input_container mb-10">
            <div className="text-black-600 font-roboto font-normal text-xs pb-2">
              DOB
            </div>
            <CommonDatePicker
              onChangeMonth={(value, isValidDate) => {
                setFieldValue('month', value, true);
                setFieldTouched('month', true, false);
                if (!isValidDate) {
                  setFieldValue(
                    'date',
                    {
                      value: '',
                      label: 'Date'
                    },
                    true
                  );
                }
              }}
              onChangeYear={(value, isValidDate) => {
                setFieldValue('year', value, true);
                setFieldTouched('year', true, false);

                if (!isValidDate) {
                  setFieldValue(
                    'date',
                    {
                      value: '',
                      label: 'Date'
                    },
                    true
                  );
                }
              }}
              onChangeDate={value => {
                setFieldValue('date', value, true);
                setFieldTouched('date', true, false);
              }}
              valueMonth={values.month}
              valueYear={values.year}
              valueDate={values.date}
              errorYear={touched.year && get(errors, 'year.value', false)}
              touchedYear={touched.year}
              onBlurYear={() => {
                setFieldTouched('year', true, true);
              }}
              errorMonth={touched.month && get(errors, 'month.value', false)}
              touchedMonth={touched.month}
              onBlurMonth={() => {
                setFieldTouched('month', true, true);
              }}
              // errors.date.value
              errorDate={touched.date && get(errors, 'date.value', false)}
              touchedDate={touched.date}
              onBlurDate={() => {
                setFieldTouched('date', true, true);
              }}
              //  errorMsg= "DOB is not selected"
              type="dob"
            />
          </div>
        </div>
        <div className="pincode_field">
          <div className="grid_input_container mb-10">
            <div>
              <CommonPincode
                stylesContainer={{
                  minWidth: '100%'
                }}
                name="pincode"
                id="pincode"
                value={values.pincode}
                onLoad={
                  values.pincode.length == 6 && loading
                    ? (setLoading(false),
                      getPinCodeInfo(values.pincode).then(res => {
                        let data;
                        try {
                          data = res.data[0].PostOffice[0];
                        } catch {
                          data = false;
                        }
                        if (data) {
                          setFieldValue('city', data.District);
                          setFieldValue('state', data.State);
                          setPincodeStatus(true);
                        } else {
                          setFieldError('pincode', 'Pincode is not valid');
                        }
                      }))
                    : null
                }
                onChange={e => {
                  pincodeStatus ? setPincodeStatus(false) : null;
                  if (e.target.value.length > 6) {
                    return;
                  }
                  if (e.target.length < 6) {
                    setFieldValue('city', '');
                    setFieldValue('state', '');
                  }

                  handleChange(e);
                }}
                error={errors.pincode}
                // error={touched.pincode && errors.pincode}
                errorMsg={errors.pincode}
                touched={touched.pincode}
                onPinCodeSucessOrFailure={obj => {
                  const { err, data } = obj;

                  if (!err && data) {
                    setFieldValue('city', data.District);
                    setFieldValue('state', data.State);
                    setPincodeStatus(true);
                  } else {
                    setFieldError('pincode', 'Pincode is not valid');
                  }
                }}
                onBlur={e => {
                  handleBlur(e);
                }}
              />
            </div>

            <p className="pt-3 text-green-500 text-xs">
              {values.city} {values.state}
            </p>
          </div>
        </div>
      </div>

      <div className="my-10 ">
        <button
          disabled={isSubmitting}
          className="submitButton w-56
                   lg:w-80 "
          type="submit"
          id="submit"
          disabled={
            errors.pincode ||
            get(errors, 'date.value', false) ||
            get(errors, 'month.value', false) ||
            get(errors, 'year.value', false) ||
            errors.mobile ||
            errors.email ||
            errors.lastName ||
            errors.Name ||
            !pincodeStatus
          }
        >
          CREATE MY ACCOUNT
        </button>
      </div>
    </>
  );
};
export default NewBasicDetails;
